module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvbXN0aWxlLTE1MHgxNTAucG5nIjs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mstile-150x150.png
// module id = /YVq
// module chunks = 0